var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import moment from "moment";
import ProfilePicture from "../shared/profilePicture";
import { getVirtualizedAppName } from "../../src/View/Hooks/useVirtualizedApp";
export const SURVEY_RESPONSE_BASE_PATH = () => "/app/survey/responseDetails";
export const surveyResponseDetailPath = (params) => {
    let virtualizedApp = params.virtualizedApp;
    if (!params.virtualizedApp) {
        // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string | undefined'.
        virtualizedApp = getVirtualizedAppName();
    }
    return ("/aviso/" +
        virtualizedApp +
        SURVEY_RESPONSE_BASE_PATH() +
        "/" +
        params.responseId);
};
export default class SurveyResponseDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            responseId: props.match.params.id,
            responseDetails: null,
            answers: null,
            canViewPersistenceRiskScore: false,
            canViewCourseRiskScore: false,
            randomIdSeed: Math.random() * 10000,
        };
        this.getResponseDetails();
        this.getRiskScorePermissions();
    }
    getResponseDetails() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.fetchResponseDetails();
            this.setState({
                responseDetails: data.response,
                answers: data.answers,
            });
        });
    }
    fetchResponseDetails() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(
            // @ts-expect-error - TS2339 - Property 'responseId' does not exist on type 'Readonly<{}>'.
            `/aviso/survey/responseDetailsJson?id=${this.state.responseId}`, {
                credentials: "include",
            });
            const responseJson = yield response.json();
            return responseJson.data;
        });
    }
    getRiskScorePermissions() {
        return __awaiter(this, void 0, void 0, function* () {
            const settings = yield this.fetchRiskScorePermissions();
            this.setState({
                canViewPersistenceRiskScore: settings.canViewPersistenceRiskLevels,
                canViewCourseRiskScore: settings.canViewCourseCompletionRiskLevels,
            });
        });
    }
    fetchRiskScorePermissions() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch("/aviso/analyticsConfiguration/configurationAsJson", {
                credentials: "include",
            });
            const responseJson = yield response.json();
            return responseJson.data;
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'response' implicitly has an 'any' type.
    renderResponseStatusAndTimestamp(response) {
        // If it's not 8 (pending) or 9 (completed), it's some other status, like partial or
        // whatever.
        let cssClass = "badge-warning";
        if (response.status.id === 8) {
            cssClass = "badge-dark";
        }
        else if (response.status.id === 9) {
            cssClass = "badge-success";
        }
        return (_jsxs("span", { children: [_jsx("span", { className: `badge ${cssClass}`, children: response.status.name }), " ", _jsxs("small", { className: "text-muted", children: ["on ", this.formatDate(response.statusDate)] })] }));
    }
    // @ts-expect-error - TS7006 - Parameter 'date' implicitly has an 'any' type.
    formatDate(date) {
        return moment(date).format("dddd, MMMM Do YYYY, h:mma");
    }
    // @ts-expect-error - TS7006 - Parameter 'response' implicitly has an 'any' type. | TS7006 - Parameter 'answers' implicitly has an 'any' type.
    renderResponseDetails(response, answers) {
        if (!response) {
            return "";
        }
        return (_jsx("div", { children: _jsxs("div", { children: [_jsx("div", { className: "card mb-3", children: _jsxs("div", { className: "card-body", children: [_jsx("h4", { className: "card-title", children: response.survey.displayName }), _jsx("div", { className: "form-group card-text", children: _jsxs("div", { className: "media", children: [_jsx("div", { className: "mr-2", children: _jsx(ProfilePicture
                                                // @ts-expect-error - TS2339 - Property 'canViewCourseRiskScore' does not exist on type 'Readonly<{}>'.
                                                , { 
                                                    // @ts-expect-error - TS2339 - Property 'canViewCourseRiskScore' does not exist on type 'Readonly<{}>'.
                                                    enableCourseScore: this.state.canViewCourseRiskScore, 
                                                    // @ts-expect-error - TS2339 - Property 'canViewPersistenceRiskScore' does not exist on type 'Readonly<{}>'.
                                                    enableTermScore: this.state.canViewPersistenceRiskScore, person: response.recipient }) }), _jsxs("div", { className: "media-body", children: [_jsx("h6", { className: "media-heading", children: "Recipient" }), _jsx("div", { children: response.recipient.fullName }), _jsx("div", { children: this.renderResponseStatusAndTimestamp(response) })] })] }) }), _jsx("div", { className: "form-group card-text", children: _jsxs("div", { className: "media", children: [_jsx("div", { className: "mr-2", children: _jsx(ProfilePicture, { person: response.sender }) }), _jsxs("div", { className: "media-body", children: [_jsx("h6", { className: "media-heading", children: "Sender" }), _jsx("div", { children: response.sender.fullName }), _jsx("div", { children: _jsxs("small", { className: "text-muted", children: ["Sent on ", this.formatDate(response.createdDate)] }) })] })] }) }), response.recipient.personId !== response.regarding.personId ? (_jsx("div", { className: "form-group card-text", children: _jsxs("div", { className: "media", children: [_jsx("div", { className: "mr-2", children: _jsx(ProfilePicture
                                                // @ts-expect-error - TS2339 - Property 'canViewCourseRiskScore' does not exist on type 'Readonly<{}>'.
                                                , { 
                                                    // @ts-expect-error - TS2339 - Property 'canViewCourseRiskScore' does not exist on type 'Readonly<{}>'.
                                                    enableCourseScore: this.state.canViewCourseRiskScore, 
                                                    // @ts-expect-error - TS2339 - Property 'canViewPersistenceRiskScore' does not exist on type 'Readonly<{}>'.
                                                    enableTermScore: this.state.canViewPersistenceRiskScore, person: response.regarding }) }), _jsxs("div", { className: "media-body", children: [_jsx("h6", { className: "media-heading", children: "Regarding" }), _jsx("div", { children: response.regarding.fullName })] })] }) })) : ("")] }) }), _jsx("div", { className: "card", children: _jsxs("div", { className: "card-body", children: [_jsxs("div", { className: "d-flex align-items-baseline", children: [_jsx("h4", { className: "card-title mr-3", children: "Answers" }), response.lastSync ? (_jsxs("small", { className: "text-muted", children: ["(Last Sync: ", this.formatDate(response.lastSync), ")"] })) : (_jsxs("small", { className: "text-muted", children: [_jsx("span", { className: "fa fa-exclamation" }), " This survey response has not yet synchronized."] }))] }), answers && answers.length ? (
                                // @ts-expect-error - TS7006 - Parameter 'answer' implicitly has an 'any' type.
                                answers.map((answer) => (_jsxs("div", { className: "form-group card-text", children: [_jsx("label", { 
                                            // @ts-expect-error - TS2339 - Property 'randomIdSeed' does not exist on type 'Readonly<{}>'.
                                            htmlFor: this.state.randomIdSeed + "-answer-" + answer.id, className: "font-weight-bold mb-0", 
                                            // eslint-disable-next-line react/no-danger
                                            dangerouslySetInnerHTML: { __html: answer.heading } }), answer.downloadUrl ? (_jsx("div", { 
                                            // @ts-expect-error - TS2339 - Property 'randomIdSeed' does not exist on type 'Readonly<{}>'.
                                            id: this.state.randomIdSeed + "-answer-" + answer.id, children: _jsx("div", { children: _jsxs("a", { href: answer.downloadUrl, children: [answer.answerText, " "] }) }) })) : (_jsx("div", { 
                                            // @ts-expect-error - TS2339 - Property 'randomIdSeed' does not exist on type 'Readonly<{}>'.
                                            id: this.state.randomIdSeed + "-answer-" + answer.id, children: answer.answerText }))] }, answer.id)))) : (_jsxs("div", { className: "alert alert-info", children: [_jsx("span", { "aria-hidden": "true", className: "fa fa-info-circle" }), " ", "There are no answers on this survey response yet."] }))] }) })] }) }));
    }
    render() {
        return (_jsx("div", { className: "container-fluid", children: _jsx("div", { className: "my-3", children: this.renderResponseDetails(
                // @ts-expect-error - TS2339 - Property 'responseDetails' does not exist on type 'Readonly<{}>'.
                this.state.responseDetails, 
                // @ts-expect-error - TS2339 - Property 'answers' does not exist on type 'Readonly<{}>'.
                this.state.answers) }) }));
    }
}
